function isHoliday(date) {
    var url = "https://date.nager.at/api/v3/PublicHolidays/2024/DE";
    var dateString = date.toISOString().split('T')[0]; // Format date to YYYY-MM-DD

    $.getJSON(url, function(data) {
        var isHoliday = data.some(holiday => holiday.date === dateString);
        return isHoliday;
    }).fail(function() {
        console.error('Failed to fetch data from the API');
    });
}

function isHolidayOLD(date){
  var url = "https://date.nager.at/api/v3/PublicHolidays/2024/DE";
  var day = (date.getDate() < 10) ? "0"+date.getDate() : date.getDate();
  var dateString = day + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();

  var holidays = [];
  $.getJSON(url, function(data){
    for(var i = 0; i < data.length; i++){
      var obj = {day: data[i].date, name: data[i].name};
      holidays[i] = obj;
    }
  });

  return holidays.some(holiday => holiday.day === date.toISOString().split('T')[0]);
}

function isBusinessDay(date) {
  const dayOfWeek = date.getDay();
  return dayOfWeek > 0 && dayOfWeek < 6;
}

function nextBusinessDay(date) {

  let nextDay = new Date(date);
  nextDay.setDate(date.getDate() + 1);

  while (!isBusinessDay(nextDay) || isHoliday(nextDay)) {
    nextDay.setDate(nextDay.getDate() + 1);
  }

  return nextDay;
}

function countdownToDispatch() {

  const now = new Date();
  let dispatchDate;

  //If it's before 11AM, a business day, and not a holiday, our dispatch date is today!

  if (now.getHours() < 11 && isBusinessDay(now) && !isHoliday(now)) {
    dispatchDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 11, 0, 0, 0);
  } else {
    dispatchDate = nextBusinessDay(now);
    dispatchDate.setHours(11, 0, 0, 0);
  }

  const timeUntilDispatch = dispatchDate.getTime() - now.getTime();
  const hours = Math.floor((timeUntilDispatch % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeUntilDispatch % (1000 * 60 * 60)) / (1000 * 60));

  let timeString = '';

  if (hours > 0) {
    timeString += hours + ' Stunden ';
  }
  if (minutes > 0) {
    timeString += minutes + ' Minuten ';
  }

  return timeString.trim();
}

function setOrderArrivalDate() {
  const now = new Date();

  let dispatchDate;
  let dispatchToday;
  if (now.getHours() < 11 && isBusinessDay(now) && !isHoliday(now) && now.getDay() != 6) {
    dispatchDate = now;
    dispatchToday = true;
  } else {
    dispatchDate = nextBusinessDay(now);
    dispatchToday = false;
  }

  const arrivalDate = nextBusinessDay(dispatchDate);
  let result = countdownToDispatch();

  const formattedDate = arrivalDate.toLocaleDateString("de-DE", {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });

  const deliveryText = document.getElementById("delivery-text");
  if (dispatchToday === true) {
  deliveryText.innerHTML = 'Voraussichtliche Lieferung am ' + formattedDate + ':</br> Bestelle innerhalb ' + result;
  } else {
    deliveryText.innerHTML = 'Voraussichtliche Lieferung am ' + formattedDate
  }

}

setInterval(setOrderArrivalDate, 1000);